import React, { Component } from 'react';
import axios from 'axios'
import { withStyles, Button } from "@material-ui/core";
import clsx from 'clsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowRight, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { faUserCrown, faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';
import ReactSelect from '../../../../common/components/UI/Select/ReactSelect';
import ActionButtons from '../../../../common/components/UI/ActionButtons/ActionButtons';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { updateSnackbar, updateShowSidePanel, updateSelectedPaycode } from '../actions';
import moment from 'moment';
import ChipTagStatus from '../../../../common/components/UI/ChipTagStatus/ChipTagStatus';
import ModalV2 from '../../UI/Modal-Material/ModalV2';
import { genDatePicker, exists, currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';
import cloneDeep from 'lodash/cloneDeep';
import { evalForeverDateToString, evalForeverToNull, evalForeverStringToDate, evalDisabledDateRanges } from './functions';
import RadioButtons from '../../../../common/components/UI/RadioGroup/RadioButtons';
import { handleAPIErrors } from '../../../auxilaries'
import { SummaryReliefStatus } from '../../../Enums/Status';
import { UkgDateFormat } from '../../../Enums';
import DateFormatService from '../../../services/DateFormatService';

const ENDPOINTS = {
    PAUSE_SHIFT_LINE_OWNER_SUMMARY: 'PauseOwnerAssignmentSummary',
    STOP_SHIFT_LINE_OWNER_SUMMARY: 'StopOwnerAssignmentSummary'
}

const styles = theme => ({
    employeeForm: {
        overflow: 'hidden',
        transition: 'height 300ms ease-out',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        border: '2px solid #3f51b5',
        padding: 12,
        borderRadius: 4
    },
    employeeFormName: {
        height: 200,
    },
    employeeFormCollapse: {
        height: 0,
        margin: 0,
        padding: 0,
        border: 0
    },

    summarySection: {
        overflow: 'hidden',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '8px -20px',
        padding: '0 20px',
        backgroundColor: '#ffffff'
    },
    summarySectionCollapse: {
        height: 0,
    },

    dateLabel: {
        width: '100%',
        display: 'flex',
    },
    dateTypo: {
        flex: '1',
        color: '#878787',
        fontSize: '12px'
    },
    dateInput: {
        marginTop: 7
    },
    reliefContainer: {
        border: '1px solid #cecece',
        padding: 12,
        borderRadius: 4,
        marginBottom: 8
    },
    reliefContainerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8
    },
    reliefTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#3a3a3a',
    },
    deleteLabel: {
        color: '#f13f3f',
        fontWeight: '600',
        fontSize: '12px',
        cursor: 'pointer'
    },
    chipClass: {
        marginRight: 5,
    },
    arrowIcon: {
        margin: '0 5px'
    },
    addButton: {
        textTransform: "capitalize",
        width: "100%",
        marginTop: 16,
        height: 40,
        border: '1px solid #0a54a2',
        background: '#0A54A214 0% 0% no-repeat padding-box',
        borderRadius: 4,
        opacity: 1,
        fontWeight: 'bold'
    },
    summaryHeader: {
        position: "relative",
        cursor: "pointer"
    },
    summaryArrow: {
        position: 'absolute',
        right: '5px',
        top: '4px',
        transition: 'all 0.1s linear'
    },
    rotateDown: {
        transform: 'rotate(180deg)'
    }
})

const dateFormat = 'YYYY-MM-DD';

class actionFormAssignEmployee extends Component {
    constructor(props) {
        super(props);
        let mainStartDate = '06/15/2020';
        let mainEndDate = '12/30/2020';
        this.state = {
            showNewForm: false,
            mainStartDate: mainStartDate,
            mainEndDate: mainEndDate,
            effectiveDatePause: null,
            endDatePause: null,
            stopDate: null,
            periodStart: mainStartDate,
            periodEnd: mainEndDate,
            showPeriodsSummary: true,
            showModal: false,
            reliefs: [],
            initialReliefs: [],
            owners: props.shiftLine.owners.map(owner => {
                return {
                    ...owner,
                    isNew: false,
                    detailsChanged: false,
                    isReliefsDatesUpdated: false,
                }
            }),
            modifiedReliefs: [],
            summaryReliefs: props.shiftLine.summaryReliefs,
            showPopopOverlap: false,
            radioOverlapSelected: 'no',
            reliefOverlapped: [],
            listUpdatedOwners: [],
            ownerForm: {
                id: "newOwner",
                type: "owner",
                startDate: null,
                endDate: null,
                isOwner: true,
            },
            overrideOverlap: false,
            newReliefForm: {
                type: "relief",
                startDate: null,
                endDate: null,
                isOwner: false,
                employee: "",
                isNew: true,
                markAsDelete: false,
                id: 'newReliefForm'
            },
            fullOwner: false,
            currentSubAction: 0, // 0 = addReplacement, 1 = handleChange
            lastUpdatedOwner: {},
            formattedEmployeeList: this.formatEmployeeList(props.employeeList, props.shiftLine),
        }
    }

    componentDidMount = () => {
        let mainPeriod = this.getMainDates();
        let auxReliefs = this.manageMainPeriods();
        this.setState({
            newReliefForm: {
                ...this.state.newReliefForm,
                employee: this.state.formattedEmployeeList[0],
            },
            reliefs: this.sortList(auxReliefs),
            initialReliefs: cloneDeep(this.sortList(auxReliefs)),
            showNewForm: this.isNewLine(),
            mainStartDate: mainPeriod.startDate ? mainPeriod.startDate.format("MM/DD/YYYY") : "",
            mainEndDate: mainPeriod.endDate ? mainPeriod.endDate.format("MM/DD/YYYY") : "",
            periodStart: mainPeriod.startDate ? mainPeriod.startDate.format("MM/DD/YYYY") : "",
            periodEnd: mainPeriod.endDate ? mainPeriod.endDate.format("MM/DD/YYYY") : "",
            fullOwner: (this.props.action === "PauseShiftLineOwner" || this.props.action === "StopShiftLineOwner") ? false : this.fullOwner(this.props.shiftLine.owners)
        })
    }

    manageMainPeriods = _ => {
        const { summaryReliefs } = this.state;

        if (summaryReliefs.length > 0) {
            let reliefs = summaryReliefs.map(x => {
                let id = null; //Math.floor(Date.now() / 1000) + Math.floor(Math.random() * 100);

                if (x.isOwner) {
                    id = x.ownerEntityId;
                } else {
                    if (x.reliefId !== null) {
                        id = x.reliefId;
                    }
                }

                return {
                    id,
                    startDate: x.startDate === null ? null : x.startDate,
                    endDate: x.endDate,
                    type: x.isOwner ? "owner" : "relief",
                    employee: x.employeeName === "UnAssigned" ? "" : { value: x.employeeId, label: x.employeeName },
                    isNew: false,
                    states: x.states,
                    markAsDelete: false,
                    summaryReliefStatus: x.summaryReliefStatus,
                    summaryReliefStatusLabel: x.sumSummaryReliefStatusLabel
                }
            });
            return this.sortList(reliefs);
        }

        return []
    }

    getMainDates = _ => {
        const { selectedWorkPlan, shiftLine } = this.props;
        if (shiftLine.states.length !== 0) {
            let auxShiftStart = shiftLine.effectiveDate
                ? moment(shiftLine.effectiveDate)
                : moment(selectedWorkPlan.startDate, dateFormat)
            let auxShiftEnd = shiftLine.endDate
                ? moment(shiftLine.endDate)
                : moment(selectedWorkPlan.endDate, dateFormat)

            return {
                startDate: moment(selectedWorkPlan.startDate, dateFormat).isSameOrAfter(auxShiftStart)
                    ? auxShiftStart
                    : moment(selectedWorkPlan.startDate, dateFormat),
                endDate: moment(auxShiftEnd).isSameOrBefore(moment(selectedWorkPlan.endDate, dateFormat))
                    ? auxShiftEnd
                    : moment(selectedWorkPlan.endDate, dateFormat),
            }
        }
        if (selectedWorkPlan.states.length !== 0) {
            return {
                startDate: moment(selectedWorkPlan.startDate, dateFormat),
                endDate: moment(selectedWorkPlan.endDate, dateFormat),
            }
        }
        return {
            startDate: null,
            endDate: null,
        }
    }

    getMinDateOwner = (date) => {
        const { shiftLine } = this.props;
        const { reliefs } = this.state;
        const disabledSummarySegmentStatses = [0, 2, 3]
        let minDate = shiftLine.effectiveDate;

        if (reliefs) {
            let startDateAux = date === 0 ? moment() : moment(date);
            let filteredSegments = reliefs.filter(segment => segment.type === 'owner' || disabledSummarySegmentStatses.includes(segment.summaryReliefStatus))
            for (const segment of filteredSegments) {
                if (startDateAux.isAfter(moment(segment.endDate))) {
                    minDate = moment(segment.endDate).add(1, 'd');
                    break
                }
            }
        }
        return moment(minDate).isBefore(moment())
            ? moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD', false)
            : moment(minDate)
    }

    getMaxDateOwner = (startDate, isNew) => {
        const { shiftLine } = this.props;
        const { owners } = this.state;
        let maxDate = shiftLine.endDate;

        if (!isNew) {
            for (const owner of owners) {
                if (moment(owner.startDate).isAfter(moment(startDate))) {
                    maxDate = moment(owner.startDate).subtract(1, 'd').format(dateFormat);
                }
            }
        }

        const stopState = shiftLine.states.find(x => x.status === 2);
        if (stopState) {
            const maxEndDate = moment(stopState.endDate, dateFormat).add(-1, 'days');
            if (moment(maxDate, dateFormat).isAfter(maxEndDate)) {
                maxDate = maxEndDate.format(dateFormat);
            }
        }

        return moment(maxDate, 'YYYY-MM-DD');
    }

    /**
     *  @param currentSubAction 0 = addReplacement, 1 = handleChange
     *
     * @memberof actionFormAssignEmployee
     */
    handleSubmitPopopOverlap = () => {
        const { currentSubAction } = this.state
        this.setState({
            showPopopOverlap: false,
        }, () => {            
            switch (currentSubAction) {
                case 0:
                    this.addReplacement()
                    break;
                case 1:
                    this.handleChange(null, { id: null })
                    break
                default:
                    return
            }
        });
    }

    checkOwnerOverlapRelief = (owner) => {
        const { reliefs } = this.state;
        let reliefOverlapped = [];

        const overlaps = (startA, endA, startB, endB) => startA.isSameOrBefore(endB) && endA.isSameOrAfter(startB);

        for (const summary of reliefs) {
            if (summary.ownerEntityId !== owner.ownerEntityId && summary.summaryReliefStatus !== 4 && summary.summaryReliefStatus !== 0 && summary.type !== 'owner') {
                let summaryStartDate = moment(summary.startDate);
                let summaryEndDate = moment((summary.endDate));
                let ownerStartDate = moment(owner.startDate);
                let ownerEndDate = moment((owner.endDate));

                let isReliefInPauseState = !owner.isNew ? owner.states.find(state => state.status === 1 && summaryStartDate.isBetween(moment(state.effectiveDate), moment(state.endDate), 'd', '[]') && summaryEndDate.isBetween(moment(state.effectiveDate), moment(state.endDate), 'd', '[]')) : false

                if (summary.employeeId !== null && !isReliefInPauseState && overlaps(summaryStartDate, summaryEndDate, ownerStartDate, ownerEndDate)) {
                    reliefOverlapped.push(summary)
                }
            }
        }

        return reliefOverlapped;
    }

    employeeShiftForm = (formData) => {
        const { action, selectedWorkPlan, classes, shiftLine } = this.props;
        const { reliefs, effectiveDatePause, endDatePause, stopDate, formattedEmployeeList } = this.state
        
        let newLine = this.isNewLine();
        let minStartDate;
        let maxStartDate;
        let maxEndDate;
        let disableStartDate = false;
        let disableEndDate = false;
        let dateRanges = evalDisabledDateRanges(reliefs, action === 'ManageOwners' ? 'owner' : 'relief', { id: formData.id, target: "startDate" }).filter(range => !range.isDisabled)
        const isDateRangesValid = dateRanges.length
            ? dateRanges.reduce((acc, val) => acc || !moment(val.startDate).isSame(moment(val.endDate)), false)
            : true;
        const isNewOrchanged = formData.isNew || !!formData.detailsChanged;

        switch (action) {
            case "ManageOwners":
                minStartDate = this.getMinDateOwner(formData.startDate);
                maxStartDate = this.getMaxDateOwner(formData.startDate, formData.id === 'newReliefForm');
                maxEndDate = this.getMaxDateOwner(formData.startDate);
                disableStartDate = !isDateRangesValid
                    || (!formData.isNew && formData.type !== "owner")
                    || moment(formData.startDate).isBefore(moment(), 'day')
                    || (moment(formData.startDate).isSame(moment(), 'day') && !isNewOrchanged);
                disableEndDate = disableStartDate;
                break;
            case "PauseShiftLineOwner":
                minStartDate = moment(effectiveDatePause);
                maxStartDate = moment(evalForeverStringToDate(endDatePause)).subtract(1, 'd');
                maxEndDate = moment(evalForeverStringToDate(endDatePause));
                if (formData.id !== "newReliefForm") {
                    disableStartDate = true
                    disableEndDate = true
                }
                break;
            case "StopShiftLineOwner":
                minStartDate = moment(stopDate).add(1, 'd');
                maxStartDate = moment(evalForeverStringToDate(shiftLine.endDate)).subtract(1, 'd');
                maxEndDate = moment(evalForeverStringToDate(shiftLine.endDate));
                if (formData.id !== "newReliefForm") {
                    disableStartDate = true
                    disableEndDate = true
                }
                break
            default:
                if (formData.type === 'owner') {
                    disableStartDate = true
                    disableEndDate = true
                } else {
                    minStartDate = this.getMinDateOwner(formData.startDate);
                    maxStartDate = this.getMaxDateOwner(formData.startDate, formData.id === 'newReliefForm');
                    maxEndDate = this.getMaxDate({ id: formData.id, target: "endDate" });
                    disableStartDate = (formData.startDate && moment(formData.startDate).isBefore(moment(), 'day')) || (selectedWorkPlan.states.length === 0) || !isDateRangesValid;
                    disableEndDate = (formData.endDate && moment(formData.endDate).isBefore(moment(), 'day')) || (selectedWorkPlan.states.length === 0) || formData.startDate === null || !isDateRangesValid;
                }
                break;
        }

        return (
            <React.Fragment>
                <ReactSelect
                    isDisabled={
                        // (formData.type === "owner" && formData.label !== "Unassigned")
                        moment(formData.startDate).isBefore(moment(), 'day')
                        || (!formData.isNew && selectedWorkPlan.status !== 0)
                        || (moment(formData.startDate).isSame(moment(), 'day') && !isNewOrchanged)
                        || (action === "ManageOwners" && formData.type !== "owner" && !formData.isNew)
                        || (action !== 'ManageAssignment' && formData.type === 'relief' && !formData.isNew)
                    }
                    value={formData.employee !== "" ? formData.employee : null}
                    labelText={"Employee"}
                    placeholder={"Select an employee"}
                    options={formattedEmployeeList}
                    getOptionValue={(opt) => opt.name}
                    getOptionLabel={(opt) => (
                        <>
                            <span>{opt.label}{opt.personNumber ? ` (${opt.personNumber})` : ''}</span>
                            {opt.isJobTransfer &&
                                <FontAwesomeIcon style={{ marginLeft: '10px', marginRight: '18px' }} icon={faExchangeAlt} />
                            }
                        </>
                    )}
                    isSearchable={true}
                    onChange={(event, value) => this.handleChange(value, { id: formData.id, target: "employee" })}
                />
                {newLine ? "" :
                    <div style={{ display: 'flex', gap: 12 }}>                        
                        {genDatePicker(
                            classes,
                            formData.startDate !== null ? moment(formData.startDate).format(dateFormat) : undefined,
                            { id: formData.id, target: "startDate" },
                            (e, v) => {
                                if (action === 'ManageOwners' && formData.id !== 'newReliefForm') {
                                    this.overlapPromptHandleChange(e, v)
                                } else {
                                    this.handleChange(e, v)
                                }
                            },
                            "Effective Date",
                            false,
                            minStartDate,
                            maxStartDate,
                            this.disabledDay,
                            disableStartDate
                        )}
                        {genDatePicker(
                            classes,
                            ((!exists(formData.endDate) || formData.endDate === null) ? '' : ((formData.endDate === 'Forever' || formData.endDate === '3000-01-01' || moment(formData.endDate).format(dateFormat) === '3000-01-01') ? 'Forever' : moment(formData.endDate).format(dateFormat))),
                            { id: formData.id, target: "endDate" },
                            (e, v) => {
                                if (action === 'ManageOwners' && formData.id !== 'newReliefForm') {
                                    this.overlapPromptHandleChange(e, v)
                                } else {
                                    this.handleChange(e, v)
                                }
                            },
                            "End Date",
                            false,
                            formData.startDate && moment(formData.startDate) >= moment() ? moment(formData.startDate).add(1, 'd') : minStartDate,
                            maxEndDate,
                            this.disabledDay,
                            disableEndDate,
                            true
                        )}
                    </div>
                }
            </React.Fragment>
        )
    }

    formatEmployeeList = (employeeList, shiftLine) => {
        let formattedEmployeeList = [];

        const jobTransfers = shiftLine.shiftTemplates
            .flatMap(shiftTemplate => shiftTemplate.kronosShiftTemplate.segments
                .reduce((acc, val) => {
                    if (val.segmentType.id === 3) {
                        if (val.orgNode) {
                            acc = [...acc, (val.orgNode || {}).qualifier];
                        }
                    }
                    return acc;
                }, []))
            .filter((val, i, arr) => arr.indexOf(val) === i);

        for (let employee of employeeList) {
            const transfersInTransferSet = jobTransfers.reduce((acc, val) => {
                return acc && employee.transferNodes.some(node => (val || []).includes(node))
            }, true);

            if (!transfersInTransferSet) {
                continue;
            }

            let jobFound = employee.jobs.find(x => x.jobId === shiftLine.job.value)
            formattedEmployeeList.push({
                value: employee.value,
                label: employee.label,
                name: employee.label,
                isJobTransfer: jobFound.isJobTransfer,
                personNumber: employee.personNumber,
            })
        }
        return formattedEmployeeList
    }

    isNewLine = () => {
        const { action, shiftLine } = this.props;
        return (action === "ManageOwners" && shiftLine.states.length === 0);
    }

    getMaxDatePause = data => {
        const { action } = this.props;
        const { mainEndDate, effectiveDatePause, reliefs } = this.state;
        
        if (action === "StopShiftLineOwner") {
            return moment(mainEndDate, "MM/DD/YYYY");
        }
        if (data.target === 'endDatePause') {
            if (effectiveDatePause) {
                for (let i = 0; i < reliefs.length; i++) {
                    if (moment(effectiveDatePause).isBetween(reliefs[i].startDate, reliefs[i].endDate, 'day', '[]') && reliefs[i].type === "owner") {
                        return moment(reliefs[i].endDate);
                    }
                }
            }
            return moment(mainEndDate, "MM/DD/YYYY");
        }
        if (data.target === 'effectiveDatePause') {
            return moment(mainEndDate, "MM/DD/YYYY").subtract(1, 'd');
        }
    }

    getMinDatePause = data => {
        const { action } = this.props;
        const { mainStartDate, effectiveDatePause, reliefs } = this.state;
        if (action === "StopShiftLineOwner") {
            for (let i = 0; i < reliefs.length; i++) {
                if (reliefs[i].type === "owner") {
                    if (moment().isBetween(reliefs[i].startDate, reliefs[i].endDate, 'day', '[]')) {
                        return moment();
                    }
                    else {
                        if (moment().isBefore(reliefs[i].startDate, 'day')) {
                            return moment(reliefs[i].startDate);
                        }
                    }
                }
            }
            return moment();
        }
        if (data.target === 'endDatePause') {
            if (effectiveDatePause) {
                return moment(effectiveDatePause).isBefore(moment(), 'day') ? moment().add(1, 'd') : moment(effectiveDatePause).add(1, 'd');
            } else {
                return moment(mainStartDate, "MM/DD/YYYY").isBefore(moment(), 'day') ? moment().add(1, 'd') : moment(mainStartDate, "MM/DD/YYYY").add(1, 'd');
            }
        }
        if (data.target === 'effectiveDatePause') {
            return moment(mainStartDate, "MM/DD/YYYY").isBefore(moment(), 'day') ? moment() : moment(mainStartDate, "MM/DD/YYYY");
        }
    }

    getMaxDate = data => {
        const { newReliefForm, reliefs } = this.state;
        const { shiftLine } = this.props
        let auxData = data.id === 'newReliefForm' ? cloneDeep(newReliefForm) : cloneDeep(reliefs.find(x => x.id === data.id));
        
        if (data.id === 'newReliefForm') {
            let maxEndDate = shiftLine.endDate;
            const segment = reliefs.find(x => moment(auxData.startDate).isBetween(moment(x.startDate), moment(x.endDate), 'day', '[]'));
            if (segment) {
                maxEndDate = segment.endDate;
            }
            return moment(evalForeverStringToDate(maxEndDate));
        }

        if (data.id !== 'newReliefForm' && reliefs.length > 0 && auxData.startDate !== null) {

            const reliefIndex = reliefs.findIndex(x => x.id === data.id);
            const nextSegment = reliefs[reliefIndex + 1];
            if (nextSegment && nextSegment.summaryReliefStatus === SummaryReliefStatus.UnAssign) {
                return moment(evalForeverStringToDate(nextSegment.endDate));
            }
            
            return auxData.endDate
        }

        return moment(shiftLine.endDate, 'YYYY-MM-DD')
    }

    getMinDate = data => {
        const { newReliefForm, periodStart, reliefs, effectiveDatePause } = this.state;
        const { action } = this.props

        let auxData = data.id === 'newReliefForm' ? cloneDeep(newReliefForm) : cloneDeep(reliefs.find(x => x.id === data.id));
        if (data.target === 'endDate' || data === 'endDate') {
            if (auxData.startDate !== null) {
                let auxDate = moment(auxData.startDate);
                auxDate = moment(auxDate).isBefore(moment(), 'day') ? moment().add(1, 'd') : auxDate.add(1, 'd');
                return auxDate;
            }
            else {
                let auxStart = action === "PauseShiftLineOwner" && effectiveDatePause ? moment(effectiveDatePause) : periodStart;
                let auxDate = moment(auxStart).isBefore(moment(), 'day') ? moment().add(1, 'd') : moment(auxStart).add(1, 'd');
                return auxDate;
            }
        }
        if ((data.target === 'startDate' || data === 'startDate') && exists(auxData)) {
            if (reliefs.length > 0) {
                for (const relief of reliefs) {
                    if (moment(relief.endDate).isBefore(moment())) {
                        continue;
                    }
                    if (relief.type !== "owner" && relief.employee.label === 'Unassigned') {
                        return moment(relief.startDate).isBefore(moment) ? moment() : relief.startDate;
                    }
                }

                return moment;
            }
            let auxStart = action === "PauseShiftLineOwner" && effectiveDatePause ? moment(effectiveDatePause) : periodStart;
            let date = moment(auxStart).isBefore(moment(), 'day') ? moment().add(1, 'd') : moment(auxStart);
            return date;
        }
    }

    disabledDay = (currentDay, target) => {
        const { action } = this.props
        const { reliefs } = this.state;
        let isStartDay = target.target === 'startDate'
        let reliefsWithoutPauseOwner = action === 'ManageOwners' ? reliefs : reliefs.filter(x => x.summaryReliefStatus !== SummaryReliefStatus.Paused);
        if (reliefsWithoutPauseOwner) {
            let dateRanges = evalDisabledDateRanges(reliefsWithoutPauseOwner, action === 'ManageOwners' ? 'owner' : 'relief', target)
            for (const range of dateRanges) {
                const rangeStartDate = moment(range.startDate);
                const rangeEndDate = moment(range.endDate);
                if (moment(currentDay).isBetween(rangeStartDate, rangeEndDate, 'd', '[]')) {
                    if (moment(currentDay).isSame(isStartDay ? rangeEndDate : rangeStartDate, 'd'))
                        return true
                    return range.isDisabled
                }
            }
        }
        return false;
    }

    disabledDayPause = (currentDay, target) => {
        const { initialReliefs } = this.state;
        let isStartDay = target.target === 'effectiveDatePause'
        for (let relief of initialReliefs) {
            if (moment(currentDay).isBetween(relief.startDate, relief.endDate, 'd', '[]') && relief.type !== "owner")
                return true;
            else if (moment(currentDay).isSame(isStartDay ? relief.endDate : relief.startDate, 'd')) {
                return true
            }
        }
        return false;
    }

    isStopDisabled = () => {
        const { initialReliefs } = this.state;
        const shiftlinesWithOwners = initialReliefs.filter((x) => x.type !== "relief");
        for (let shiftlineWithOwner of shiftlinesWithOwners) {
            if (moment(shiftlineWithOwner.endDate).isAfter(moment(), 'd', '[]')) // There is an owner that ends after today
                return false;
        }
        return true;
    }
    handleChange = async (value, data) => {
        const { reliefs, newReliefForm, owners, modifiedReliefs, radioOverlapSelected, lastUpdatedOwner } = this.state;
        const { action, handleChangeEmployee = () => { }, selectedWorkPlan, shiftLine } = this.props;

        if (data.id === "newReliefForm") {
            if (data.target === "startDate" && moment(newReliefForm.endDate).isSameOrBefore(moment(value))) {
                this.setState(prevState => ({
                    newReliefForm: {
                        ...prevState.newReliefForm,
                        startDate: value,
                        endDate: undefined
                    }
                }))
            } else {
                this.setState(prevState => ({
                    newReliefForm: {
                        ...prevState.newReliefForm,
                        [data.target]: value
                    }
                }))
            }
        } else if (data.id === "pause") {
            // TODO
            if (data.target === 'effectiveDatePause') {
                const { endDatePause } = this.state
                this.setState({
                    effectiveDatePause: value,
                    endDatePause: moment(value).isSameOrAfter(moment(endDatePause), 'd') ? null : endDatePause, // Clear if the date is greater than the end date
                }, async () => {
                    const { endDatePause, effectiveDatePause } = this.state
                    if (endDatePause) {
                        let payload = {
                            workplanId: selectedWorkPlan.workplanId,
                            shiftLineEntityId: shiftLine.shiftLineId,
                            effectiveDate: effectiveDatePause,
                            endDate: evalForeverStringToDate(endDatePause),
                            reliefs: modifiedReliefs,
                        }
                        let newReliefs = await this.updatePauseStopShiftLineOwnerAssignmentSummary(payload, modifiedReliefs, ENDPOINTS.PAUSE_SHIFT_LINE_OWNER_SUMMARY)
                        this.setState({ reliefs: newReliefs });
                        handleChangeEmployee(shiftLine, modifiedReliefs, effectiveDatePause, endDatePause)
                    }
                })
            } else { // Update end date pause
                this.setState({
                    endDatePause: value
                }, async () => {
                    const { endDatePause, effectiveDatePause } = this.state
                    let payload = {
                        workplanId: selectedWorkPlan.workplanId,
                        shiftLineEntityId: shiftLine.shiftLineId,
                        effectiveDate: effectiveDatePause,
                        endDate: evalForeverStringToDate(endDatePause),
                        reliefs: modifiedReliefs,
                    }
                    let newReliefs = await this.updatePauseStopShiftLineOwnerAssignmentSummary(payload, modifiedReliefs, ENDPOINTS.PAUSE_SHIFT_LINE_OWNER_SUMMARY)
                    this.setState({ reliefs: newReliefs });
                    handleChangeEmployee(shiftLine, modifiedReliefs, effectiveDatePause, endDatePause)
                })
            }

        } else if (data.id === "stop") {
            this.setState({
                stopDate: value
            }, async () => {
                const { stopDate } = this.state
                let payload = {
                    workplanId: selectedWorkPlan.workplanId,
                    shiftLineEntityId: shiftLine.shiftLineId,
                    endDate: evalForeverStringToDate(stopDate),
                    reliefs: modifiedReliefs,
                }
                let newReliefs = await this.updatePauseStopShiftLineOwnerAssignmentSummary(payload, modifiedReliefs, ENDPOINTS.STOP_SHIFT_LINE_OWNER_SUMMARY)
                this.setState({ reliefs: newReliefs });
                handleChangeEmployee(shiftLine, newReliefs, null, stopDate)
            })

        } else if (data.id === 'period') {
            this.setState({
                [data.target]: value
            })
        }
        else if (action === "ManageAssignment") {
            let newModifiedReliefs = [...modifiedReliefs]
            if (!modifiedReliefs.some(relief => relief.id === data.id)) {
                let updatedExistingRelief = reliefs.find(relief => relief.id === data.id)
                newModifiedReliefs.push({ ...updatedExistingRelief, [data.target]: value, detailsChanged: true })
            } else {
                newModifiedReliefs = newModifiedReliefs.map(relief => {                    
                    if (relief.id === data.id) {
                        let newRelief = { ...relief, [data.target]: value, detailsChanged: relief.isNew || relief.markedAsDelete ? false : true }
                        if (data.target === "startDate" && moment(evalForeverStringToDate(newRelief.endDate)).isBefore(moment(newRelief.startDate), 'd')) {
                            newRelief.endDate = moment(newRelief.startDate).add(1, 'd').format(dateFormat)
                        }
                        return newRelief
                    }
                    return relief
                })
            }
            let payload = {
                workplanId: selectedWorkPlan.workplanId,
                shiftLineEntityId: shiftLine.shiftLineId,
                reliefs: newModifiedReliefs.map(relief => {
                    return {
                        reliefEntityId: relief.id,
                        employeeId: relief.employee.value,
                        employeeName: relief.employee.label,
                        startDate: moment(relief.startDate).format('YYYY-MM-DD'),
                        endDate: evalForeverToNull(relief.endDate) !== null ? moment(relief.endDate).format('YYYY-MM-DD') : null,
                        isNew: relief.isNew,
                        detailsChanged: relief.isNew || relief.markedAsDelete ? false : true,
                        markedForDeletion: relief.markedAsDelete,
                        tempId: relief.id,
                        isJobTransfer: relief.employee.isJobTransfer
                    }
                }),
            }

            let newReliefs = await this.updateAssignmentTimelineSummary(payload, newModifiedReliefs)
            this.setState({ modifiedReliefs: newModifiedReliefs, reliefs: newReliefs })
            handleChangeEmployee(shiftLine, newReliefs);
        } else if (action === "ManageOwners") {
            let ownersAux = owners.map(owner => {
                // bandaid fix
                if (data.target === 'employee' && owner.ownerEntityId === data.id) {
                    return {
                        ...owner,
                        employeeFullName: value.name,
                        employeeId: value.value,
                        isJobTransfer: value.isJobTransfer,
                        detailsChanged: owner.isNew ? false : true,
                    }
                } else if (owner.ownerEntityId === lastUpdatedOwner.ownerEntityId) {
                    return {
                        ...owner,
                        isReliefsDatesUpdated: radioOverlapSelected === 'yes'
                    }
                }
                return owner
            });

            let payload = {
                workplanId: selectedWorkPlan.workplanId,
                shiftLineEntityId: shiftLine.shiftLineId,
                owners: ownersAux.map(owner => {
                    let newOwner = {
                        employeeName: owner.employeeFullName,
                        employeeId: owner.employeeId,
                        startDate: owner.startDate,
                        endDate: evalForeverToNull(owner.endDate),
                        isReliefsDatesUpdated: owner.isReliefsDatesUpdated, // TODO : check if it overlaps with reliefs and prompt user
                        isNew: owner.isNew,
                        ownerEntityId: owner.isNew ? null : owner.ownerEntityId,
                        tempId: owner.isNew ? owner.ownerEntityId : null,
                        detailsChanged: owner.detailsChanged,
                        isJobTransfer: owner.isJobTransfer,
                        markedForDeletion: owner.markedForDeletion
                    }
                    // bandaid fix
                    if (data.target !== 'employee' && owner.ownerEntityId === data.id) {
                        newOwner = {
                            ...newOwner,
                            [data.target]: moment(value),
                            detailsChanged: owner.isNew ? false : true,
                        }
                    }
                    return newOwner
                })
            }
            let newReliefs = await this.updateOwnerTimelineSummary(payload, ownersAux)

            this.setState({ owners: ownersAux, reliefs: newReliefs, radioOverlapSelected: 'no' });
            handleChangeEmployee(shiftLine, { value: lastUpdatedOwner.employeeId, label: lastUpdatedOwner.employeeFullName }, ownersAux);
        }
    }

    addReplacement = async () => {
        const { handleChangeOwners = () => { }, handleChangeEmployee = () => { }, shiftLine, action, selectedWorkPlan } = this.props;
        const { reliefs, newReliefForm, owners, modifiedReliefs, effectiveDatePause, endDatePause, stopDate, radioOverlapSelected } = this.state;
        let auxReliefs = cloneDeep(reliefs);
        let auxNewReliefForm = cloneDeep(newReliefForm);
        let newModifiedReliefs = [...modifiedReliefs]
        let fullOwnerAux = false;
        let ownersAux = owners;
        auxNewReliefForm.id = Math.floor(Date.now() / 1000) + Math.floor(Math.random() * 100);
        auxNewReliefForm.isNew = true;
        let payload;        
        
        switch (action) {
            case 'ManageOwners':
                auxNewReliefForm.type = "owner";

                let owner = {
                    ownerEntityId: auxNewReliefForm.id,
                    employeeId: auxNewReliefForm.employee.value,
                    employeeFullName: auxNewReliefForm.employee.name,
                    employeeName: auxNewReliefForm.employee.name,
                    startDate: auxNewReliefForm.startDate,
                    endDate: auxNewReliefForm.endDate,
                    startDateEpoch: moment(auxNewReliefForm.startDate).unix(),
                    endDateEpoch: moment(evalForeverStringToDate(auxNewReliefForm.endDate)).unix(),
                    isNew: true,
                    detailsChanged: false,
                    isReliefsDatesUpdated: radioOverlapSelected === 'yes',
                    isJobTransfer: auxNewReliefForm.employee.isJobTransfer,
                }

                ownersAux.push(owner)
                fullOwnerAux = this.fullOwner(ownersAux);
                if (auxNewReliefForm.employee !== "") {
                    handleChangeOwners(ownersAux);
                }

                payload = {
                    workplanId: selectedWorkPlan.workplanId,
                    shiftLineEntityId: shiftLine.shiftLineId,
                    owners: ownersAux.map(owner => {
                        return {
                            employeeName: owner.employeeFullName,
                            employeeId: owner.employeeId,
                            startDate: owner.startDate,
                            endDate: evalForeverToNull(owner.endDate),
                            isReliefsDatesUpdated: owner.isReliefsDatesUpdated, // TODO : check if it overlaps with reliefs and prompt user
                            isNew: owner.isNew,
                            detailsChanged: owner.detailsChanged ? owner.detailsChanged : false,
                            markedForDeletion: owner.markedForDeletion,
                            tempId: owner.ownerEntityId,
                            isJobTransfer: owner.isJobTransfer
                        }
                    })
                }
                auxReliefs = await this.updateOwnerTimelineSummary(payload, ownersAux, auxNewReliefForm)
                break
            case 'ManageAssignment':
                
                
                newModifiedReliefs.push(auxNewReliefForm)
                payload = {
                    workplanId: selectedWorkPlan.workplanId,
                    shiftLineEntityId: shiftLine.shiftLineId,
                    reliefs: newModifiedReliefs.map(relief => {
                        return {
                            reliefEntityId: relief.id,
                            employeeId: relief.employee.value,
                            employeeName: relief.employee.name,
                            startDate: relief.startDate,
                            endDate: evalForeverToNull(relief.endDate) ? relief.endDate : null,
                            isNew: typeof relief.isNew !== 'undefined' ? relief.isNew : true,
                            detailsChanged: relief.detailsChanged,
                            markedForDeletion: relief.markAsDelete,
                            tempId: relief.id,
                            isJobTransfer: relief.employee.isJobTransfer
                        }
                    }),
                }

                auxReliefs = await this.updateAssignmentTimelineSummary(payload, newModifiedReliefs)
                handleChangeEmployee(shiftLine, newModifiedReliefs)
                break
            case 'PauseShiftLineOwner':
                newModifiedReliefs.push(auxNewReliefForm)
                payload = {
                    workplanId: selectedWorkPlan.workplanId,
                    shiftLineEntityId: shiftLine.shiftLineId,
                    effectiveDate: effectiveDatePause,
                    endDate: endDatePause,
                    reliefs: newModifiedReliefs.map(relief => {
                        return {
                            reliefEntityId: relief.id,
                            employeeId: relief.employee.value,
                            employeeName: relief.employee.name,
                            startDate: moment(relief.startDate).format('YYYY-MM-DD'),
                            endDate: evalForeverToNull(relief.endDate) ? moment(relief.endDate).format('YYYY-MM-DD') : null,
                            isNew: typeof relief.isNew !== 'undefined' ? relief.isNew : true,
                            detailsChanged: relief.detailsChanged,
                            markedForDeletion: relief.markAsDelete,
                            tempId: relief.id,
                        }
                    }),
                }
                auxReliefs = await this.updatePauseStopShiftLineOwnerAssignmentSummary(payload, newModifiedReliefs, ENDPOINTS.PAUSE_SHIFT_LINE_OWNER_SUMMARY)
                handleChangeEmployee(shiftLine, newModifiedReliefs, effectiveDatePause, endDatePause)
                break
            case 'StopShiftLineOwner':
                newModifiedReliefs.push(auxNewReliefForm);
                payload = {
                    workplanId: selectedWorkPlan.workplanId,
                    shiftLineEntityId: shiftLine.shiftLineId,
                    endDate: evalForeverStringToDate(stopDate),
                    reliefs: newModifiedReliefs.map(relief => {
                        return {
                            reliefEntityId: relief.id,
                            employeeId: relief.employee.value,
                            employeeName: relief.employee.label,
                            startDate: moment(relief.startDate).format('YYYY-MM-DD'),
                            endDate: evalForeverToNull(relief.endDate) !== null ? moment(relief.endDate).format('YYYY-MM-DD') : null,
                            isNew: typeof relief.isNew !== 'undefined' ? relief.isNew : true,
                            detailsChanged: relief.detailsChanged,
                            markedForDeletion: relief.markAsDelete,
                            tempId: relief.id,
                        }
                    }),
                }
                auxReliefs = await this.updatePauseStopShiftLineOwnerAssignmentSummary(payload, newModifiedReliefs, ENDPOINTS.STOP_SHIFT_LINE_OWNER_SUMMARY)
                handleChangeEmployee(shiftLine, auxReliefs, null, stopDate)
                break
            default:
                break
        }
        this.setState({
            reliefs: auxReliefs,
            owners: ownersAux,
            newReliefForm: {
                type: "relief",
                startDate: null,
                endDate: null,
                isOwner: true,
                employee: this.state.formattedEmployeeList[0],
                isNew: true,
                markAsDelete: false,
                id: "newReliefForm"
            },
            showNewForm: false,
            fullOwner: fullOwnerAux,
            modifiedReliefs: newModifiedReliefs,
            radioOverlapSelected: 'no',
        })
    }

    updateOwnerTimelineSummary = async (payload, owners) => {
        try {
            let summaryReliefs = await axios.post(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/ownersAssignmentSummary/`, payload, currentHttpOptions())
            
            let auxReliefs = summaryReliefs.data.map(relief => {
                if (relief.isOwner) {
                    let newOwner = owners.find(owner => owner.ownerEntityId === relief.tempId)
                    return {
                        employee: { value: relief.employeeId, label: relief.employeeName },
                        endDate: relief.endDate,
                        id: newOwner ? relief.tempId : relief.ownerEntityId,
                        isNew: newOwner ? true : false,
                        isOwner: true,
                        markAsDelete: false,
                        startDate: relief.startDate,
                        type: "owner",
                        states: relief.states,
                        summaryReliefStatus: relief.summaryReliefStatus,
                        isJobTransfer: relief.isJobTransfer,
                        summaryReliefStatusLabel: relief.sumSummaryReliefStatusLabel
                    }
                } else {
                    return {
                        employee: { value: relief.employeeId, label: relief.employeeName },
                        endDate: relief.endDate,
                        id: relief.reliefId,
                        isNew: false,
                        isOwner: false,
                        markAsDelete: false,
                        startDate: relief.startDate,
                        type: "relief",
                        states: relief.states,
                        summaryReliefStatus: relief.summaryReliefStatus,
                        isJobTransfer: relief.isJobTransfer,
                        summaryReliefStatusLabel: relief.sumSummaryReliefStatusLabel
                    }
                }
            })
            return auxReliefs
        }
        catch (ex) {
            let errorMessage = handleAPIErrors(ex.response)
            this.props.updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: errorMessage,
                openSnackbar: true,
            })
            return []
        }
    }

    updateAssignmentTimelineSummary = async (payload, modifiedReliefs) => {
        // ReliefsAssignmentSummary
        try {
            let summarySegments = await axios.post(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/reliefsAssignmentSummary/`, payload, currentHttpOptions())
            let auxReliefs = summarySegments.data.map(segment => {
                if (segment.isOwner) {                    
                    return {
                        employee: { value: segment.employeeId, label: segment.employeeName },
                        endDate: segment.endDate === '' ? 'Forever' : segment.endDate,
                        id: segment.ownerEntityId,
                        isNew: false,
                        isOwner: true,
                        states: segment.states,
                        startDate: segment.startDate,
                        type: "owner",
                        summaryReliefStatus: segment.summaryReliefStatus,
                        summaryReliefStatusLabel: segment.sumSummaryReliefStatusLabel
                    }
                } else {
                    let newRelief = modifiedReliefs.find(relief => relief.id === segment.reliefId)
                    return {
                        employee: { value: segment.employeeId, label: segment.employeeName },
                        endDate: segment.endDate === '' ? 'Forever' : segment.endDate,
                        id: segment.reliefId,
                        isNew: newRelief ? newRelief.isNew : false,
                        isOwner: false,
                        states: segment.states,
                        markAsDelete: newRelief ? newRelief.markAsDelete : false,
                        startDate: segment.startDate,
                        type: "relief",
                        detailsChanged: newRelief ? newRelief.detailsChanged : false,
                        summaryReliefStatus: segment.summaryReliefStatus,
                        summaryReliefStatusLabel: segment.sumSummaryReliefStatusLabel
                    }
                }
            })
            return auxReliefs
        }
        catch (ex) {
            let errorMessage = handleAPIErrors(ex.response)
            this.props.updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: errorMessage,
                openSnackbar: true,
            })
            return []
        }
    }

    updatePauseStopShiftLineOwnerAssignmentSummary = async (payload, reliefs = [], endpoint) => {
        try {
            let summarySegments = await axios.post(`${process.env.REACT_APP_DOTNET_URL}/api/v1/manager/workplan/${endpoint}`, payload, currentHttpOptions())
            let auxReliefs = summarySegments.data.map(segment => {
                if (segment.isOwner) {
                    return {
                        employee: { value: segment.employeeId, label: segment.employeeName },
                        endDate: segment.endDate,
                        id: segment.ownerEntityId,
                        isNew: false,
                        isOwner: true,
                        states: segment.states,
                        startDate: segment.startDate,
                        type: "owner",
                        summaryReliefStatus: segment.summaryReliefStatus,
                        summaryReliefStatusLabel: segment.sumSummaryReliefStatusLabel
                    }
                } else {
                    let newRelief = reliefs.find(relief => relief.id === segment.reliefId)
                    return {
                        employee: { value: segment.employeeId, label: segment.employeeName },
                        endDate: segment.endDate,
                        id: segment.reliefId,
                        isNew: newRelief ? newRelief.isNew : false,
                        isOwner: false,
                        markAsDelete: newRelief ? newRelief.markAsDelete : false,
                        states: segment.states,
                        startDate: segment.startDate,
                        type: "relief",
                        detailsChanged: newRelief ? newRelief.detailsChanged : false,
                        summaryReliefStatus: segment.summaryReliefStatus,
                        summaryReliefStatusLabel: segment.sumSummaryReliefStatusLabel
                    }
                }
            })
            return auxReliefs
        } catch (ex) {
            let errorMessage = handleAPIErrors(ex.response)
            this.props.updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: errorMessage,
                openSnackbar: true,
            })
            return []
        }
    }

    deleteEntry = async id => {
        const { reliefs, modifiedReliefs } = this.state;
        const { handleChangeEmployee = () => { }, shiftLine, selectedWorkPlan } = this.props;
        let auxReliefs = [];

        let modifiedReliefExists = exists(modifiedReliefs.find(relief => relief.id === id))
        let newModifiedReliefs = modifiedReliefs.filter(relief => !(relief.id === id && relief.isNew)).map(relief => {
            return {
                ...relief,
                markAsDelete: relief.id === id ? true : relief.markAsDelete,
            }
        })

        if (!modifiedReliefExists) {
            let reliefToModify = reliefs.find(relief => relief.id === id)
            if (reliefToModify)
                newModifiedReliefs.push({ ...reliefToModify, markAsDelete: true })
        }
        let payload = {
            workplanId: selectedWorkPlan.workplanId,
            shiftLineEntityId: shiftLine.shiftLineId,
            reliefs: newModifiedReliefs.map(relief => {
                return {
                    reliefEntityId: relief.id,
                    employeeId: relief.employee.value,
                    employeeName: relief.employee.label,
                    startDate: moment(relief.startDate).format('YYYY-MM-DD'),
                    endDate: evalForeverToNull(relief.endDate) !== null ? moment(relief.endDate).format('YYYY-MM-DD') : null,
                    isNew: relief.isNew,
                    detailsChanged: false,
                    markedForDeletion: relief.markAsDelete,
                    tempId: relief.id,
                }
            }),
        }

        auxReliefs = await this.updateAssignmentTimelineSummary(payload, newModifiedReliefs)

        handleChangeEmployee(shiftLine, newModifiedReliefs)
        this.setState({
            reliefs: auxReliefs,
            modifiedReliefs: newModifiedReliefs
        })
    }

    deleteOwnerSegment = async (ownerId) => {
        const { owners } = this.state
        const { selectedWorkPlan, shiftLine, handleChangeEmployee } = this.props
        
        let updatedOwners = owners.filter((owner) => {
            return !(owner.isNew && owner.ownerEntityId === ownerId)
        }).map(owner => ({
            ...owner,
            markedForDeletion: owner.ownerEntityId === ownerId ? true : owner.markedForDeletion,
            tempId: owner.ownerEntityId
        }))
        let payload = {
            workplanId: selectedWorkPlan.workplanId,
            shiftLineEntityId: shiftLine.shiftLineId,
            owners: updatedOwners
        }
        let updatedReliefs = await this.updateOwnerTimelineSummary(payload, updatedOwners)

        this.setState({
            owners: updatedOwners, reliefs: updatedReliefs
        })
        handleChangeEmployee(shiftLine, { value: 0, label: '' }, updatedOwners);
    }

    sortList = (list) => {
        const sortedList = list.sort((a, b) => {
            return (a.startDate === null ? moment(a.endDate) : moment(a.startDate)).toISOString().localeCompare((a.startDate === null ? moment(evalForeverStringToDate(b.endDate)) : moment(b.startDate)).toISOString(), undefined, { numeric: true, sensitivity: 'base' })
        });
        return sortedList;
    }

    cancelCreation = () => {
        this.setState({
            newReliefForm: {
                startDate: null,
                endDate: null,
                isOwner: true,
                employee: "",
                isNew: true,
                markAsDelete: false,
                id: "newReliefForm"
            },
            showNewForm: false,
        })
    }

    overlapPromptHandleChange = (value, data) => {
        const { owners } = this.state
        let ownersAux = owners.map(owner => {
            if (owner.ownerEntityId === data.id) {
                let newOwner = {
                    ...owner,
                    [data.target]: value,
                    [`${data.target}Epoch`]: moment(value).unix(),
                    detailsChanged: owner.isNew ? false : true,
                }
                if (data.target === 'startDate' && moment(evalForeverStringToDate(newOwner.endDate)).isSameOrBefore(moment(newOwner.startDate), 'd')) {
                    newOwner.endDate = moment(newOwner.startDate).add(1, 'd').format(dateFormat)
                    newOwner.endDateEpoch = moment(newOwner.startDate).add(1, 'd').unix()
                }
                if (data.target === 'endDate' && moment(newOwner.startDate).isSameOrAfter(moment(evalForeverStringToDate(newOwner.endDate)), 'd')) {
                    newOwner.startDate = moment(newOwner.endDate).subtract(1, 'd').format(dateFormat)
                    newOwner.startDateEpoch = moment(newOwner.endDate).subtract(1, 'd').unix()
                }
                return newOwner
            }
            return owner
        });
        this.setState({
            owners: ownersAux,
        }, () => {
            const { owners } = this.state
            let selectedOwner = owners.find(owner => owner.ownerEntityId === data.id)
            let overlaps = this.checkOwnerOverlapRelief(selectedOwner)
            if (overlaps.length > 0) {
                this.setState({
                    showPopopOverlap: true,
                    currentSubAction: 1,
                    lastUpdatedOwner: selectedOwner
                })
            } else {
                this.handleChange(value, data)
            }
        })
    }

    overlapPromptAddReplacement = (form, callback = () => { }, event, value) => {
        let owner = {
            ownerEntityId: form.id,
            startDate: form.startDate,
            endDate: form.endDate,
            isNew: true,
        }
        let overlaps = this.checkOwnerOverlapRelief(owner)
        if (overlaps.length > 0) {
            this.setState({
                showPopopOverlap: true,
                currentSubAction: 0,
            })
        } else {
            callback(event, value)
        }
    }

    newEntryForm = (showNewEntryForm) => {
        const { newReliefForm } = this.state;
        const { classes, action } = this.props;

        return (
            <div className={`${classes.employeeForm} ${showNewEntryForm ? "" : classes.employeeFormCollapse} ${this.isNewLine() ? classes.employeeFormName : ""}`}>
                {this.employeeShiftForm(newReliefForm)}
                <ActionButtons
                    submitText={"Add Entry"}
                    cancel={() => { this.cancelCreation() }}
                    submit={() => {
                        if (action === 'ManageOwners') {
                            this.overlapPromptAddReplacement(newReliefForm, this.addReplacement)
                        } else {
                            this.addReplacement()
                        }
                    }}
                    disabledSubmit={this.submitableForm()}
                />
            </div>
        )
    }

    submitableForm = _ => {
        const { selectedWorkPlan } = this.props;
        const { newReliefForm, owners } = this.state;
        if (this.isNewLine() && selectedWorkPlan.status === 0 && owners.length > 0 && !owners[owners.length - 1].markedForDeletion) {
            return true;
        }
        else if (this.isNewLine()) {
            return newReliefForm.employee === ""
        }
        else {
            return newReliefForm.employee === "" || newReliefForm.startDate === null || newReliefForm.endDate === null
        }
    }

    summarySection = () => {
        const { shiftLine, classes, action } = this.props;
        const { reliefs, owners } = this.state;

        if (!this.isNewLine()) {
            var a = reliefs.map(x => this.summaryEntry(x));
            return  a;
        }

        const filteredOwners = owners.filter((owner) => !owner.markedForDeletion);
        if (action === "ManageOwners" && shiftLine.states.length === 0 && filteredOwners.length > 0) {
            return filteredOwners.map(owner => (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '48%', paddingBottom: 10 }}>
                        <ChipTagStatus
                            className={classes.chipClass}
                            color={'greenAlt'}
                        />
                        <span>{owner.employeeFullName}</span>
                        {<FontAwesomeIcon className={classes.arrowIcon} icon={faUserCrown} />}
                    </div>
                </div>
            ));
        }

        return (
            <span style={{ fontWeight: 'bold' }}>No summary available</span>
        );
    }

    summaryEntry = entry => {
        const { classes, t } = this.props; 
        const isBetweenTimeFrame = moment().isBetween(moment(entry.startDate), moment(evalForeverStringToDate(entry.endDate)), 'd', '[]');
        let currentState = entry.states ? entry.states.find(x => x.isCurrent) : null;
        let currentStatus = currentState ? currentState.status : 3;
        let color = isBetweenTimeFrame ? 'green' : 'greenAlt'; // should be entry.summaryReliefStatus === 1 or 4
        if (!isBetweenTimeFrame || entry.states === null) {
            color = 'white';
        }
        else if (currentStatus === 1) {
            color = isBetweenTimeFrame ? 'yellow' : 'yellowAlt';
        } else if (currentStatus === 2) {
            color = moment().isAfter(moment(entry.endDate)) ? 'red' : 'redAlt'
        }
        else if ((entry.employee.label === null && entry.startDate !== null) || !entry.states) { // should be entry.summaryReliefStatus === 3
            color = 'white';
        }

        return (
            <div key={`${entry.id}-${entry.summaryReliefStatusLabel}-${moment(entry.startDate).unix()}-${moment(entry.endDate).unix()}`}>
                <div style={{ display: 'flex', paddingLeft: entry.type === 'relief' && entry.id !== null ? 15 : '' }}>
                    <div style={{ width: '48%', paddingBottom: 10 }}>
                        <ChipTagStatus
                            className={classes.chipClass}
                            color={color}
                        />
                        <span>{entry.employee.label || t(`workPlanView.SummaryReliefStatus.${entry.summaryReliefStatusLabel}`)}</span>
                        {entry.type === "owner" ? <FontAwesomeIcon className={classes.arrowIcon} icon={faUserCrown} /> : ''}
                    </div>
                    <div style={{ paddingLeft: 16, width: '48%' }}>
                        {entry.startDate === null ? '' : <React.Fragment>
                            {DateFormatService.formatDateOrEmpty(entry.startDate, UkgDateFormat.LongDate)}
                            <FontAwesomeIcon className={classes.arrowIcon} icon={faLongArrowRight} />
                        </React.Fragment>}
                        {evalForeverDateToString(entry.endDate)}
                    </div>
                </div>
            </div>)
    }

    noPauseSelected = () => {
        const { endDatePause, effectiveDatePause } = this.state;
        return !endDatePause || !effectiveDatePause || (moment(endDatePause).diff(effectiveDatePause, 'd') < 1)
    }

    fullOwner = (owners) => {
        const { shiftLine } = this.props;
        if (owners.length === 0 || shiftLine.states.length === 0) {
            return false;
        } else {
            let minDate = this.getMinDateOwner();
            return moment(minDate).isAfter(moment(shiftLine.endDate));
        }
    }

    freeSlot = () => {
        const { reliefs } = this.state;
        if (reliefs.length > 0) {
            let auxFree = reliefs.find(x => x.employee.label === "Unassigned" && moment(evalForeverStringToDate(x.endDate)).isAfter(moment(), 'day'));
            return auxFree === undefined;
        }
        return false;
    }

    render() {
        const { classes, action } = this.props;
        const { showPeriodsSummary, reliefs, endDatePause, effectiveDatePause, stopDate, owners, fullOwner, showPopopOverlap, radioOverlapSelected,
            showNewForm, reliefOverlapped } = this.state;
        let radiosOverlap = [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
        ];

        const showNewEntryForm = showNewForm
            || (action === 'ManageOwners' && !reliefs.find(segment => segment.type === 'owner'))
            || (action === 'ManageAssignment' && !reliefs.find(segment => {
                return segment.type === 'relief' && segment.id && segment.employee !== ""
                    && segment.employee.label !== "pausedShift" && segment.employee.label !== "Unassigned"
            }));

        const renderSegments = () => {
            switch (action) {
                case 'ManageOwners':
                case 'PauseShiftLineOwner':
                case 'StopShiftLineOwner':
                    return <React.Fragment>
                        {owners.filter(x => !x.markedForDeletion).map((x) => {
                            const owner = {
                                employee: { value: x.employeeId, label: x.employeeFullName },
                                endDate: x.endDate,
                                id: x.ownerEntityId,
                                isNew: x ? x.isNew : false,
                                isOwner: true,
                                startDate: x.startDate,
                                type: "owner",
                                detailsChanged: x.detailsChanged,
                            }
                            const isNewOrchanged = owner.isNew || owner.detailsChanged;
                            const hideDeleteLabel = moment(owner.startDate).isBefore(moment(), 'day')
                                || (moment(owner.startDate).isSame(moment(), 'day') && !isNewOrchanged);
                            if (owner.id && owner.employee !== "" && owner.employee.label !== "pausedShift" && owner.employee.label !== "Unassigned") {
                                return <div key={owner.id} className={classes.reliefContainer}>
                                    <div className={classes.reliefContainerHeader}>
                                        <span className={classes.reliefTitle}>
                                            {owner.type.replace(/^\w/, (c) => c.toUpperCase())}
                                        </span>
                                        {!hideDeleteLabel &&
                                            (<div className={classes.deleteLabel} onClick={() => this.deleteOwnerSegment(owner.id)}>Delete</div>)}
                                    </div>
                                    {this.employeeShiftForm(owner)}
                                </div>
                            } else {
                                return null;
                            }
                        })}
                    </React.Fragment>
                case 'ManageAssignment':
                    return <React.Fragment>
                        {reliefs.filter(segment => (
                            segment.type === 'relief' 
                            && segment.summaryReliefStatus === SummaryReliefStatus.Active
                        )).map((x) => {
                            return (
                            <div key={x.id} className={classes.reliefContainer}>
                                <div className={classes.reliefContainerHeader}>
                                    <span className={classes.reliefTitle}>
                                        {x.type.replace(/^\w/, (c) => c.toUpperCase())}
                                    </span>
                                    {x.type === "owner" || (action !== "ManageAssignment" && !x.isNew) ? "" : <div className={classes.deleteLabel} onClick={() => this.deleteEntry(x.id)}>Delete</div>}
                                </div>
                                {this.employeeShiftForm(x)}
                            </div>
                        )})}
                    </React.Fragment>
                default:
                    return null
            }
        }

        return (
            <React.Fragment>
                <div>
                    <div className={classes.summaryHeader} onClick={_ => { this.setState({ showPeriodsSummary: !showPeriodsSummary }) }}>
                        <span style={{ fontWeight: 'bold' }}>Assignment Summary</span>
                        <FontAwesomeIcon className={clsx(classes.summaryArrow, showPeriodsSummary ? classes.rotateDown : "")} icon={faChevronDown} />
                    </div>
                    <div className={`${classes.summarySection} ${showPeriodsSummary ? "" : classes.summarySectionCollapse}`}>
                        {this.summarySection()}
                    </div>
                </div>
                {action === 'PauseShiftLineOwner' ?
                    <div style={{ display: 'flex' }}>
                        {genDatePicker(
                            classes,
                            effectiveDatePause !== null ? effectiveDatePause : undefined,
                            { id: "pause", target: "effectiveDatePause" },
                            this.handleChange,
                            "Effective Date",
                            false,
                            this.getMinDatePause({ id: "pause", target: "effectiveDatePause" }),
                            this.getMaxDatePause({ id: "pause", target: "effectiveDatePause" }),
                            this.disabledDayPause
                        )}
                        {genDatePicker(
                            classes,
                            endDatePause !== null ? evalForeverStringToDate(endDatePause) : undefined,
                            { id: "pause", target: "endDatePause" },
                            this.handleChange,
                            "End Date",
                            false,
                            this.getMinDatePause({ id: "pause", target: "endDatePause" }),
                            this.getMaxDatePause({ id: "pause", target: "endDatePause" }),
                            this.disabledDayPause,
                            effectiveDatePause === null,
                            true
                        )}
                    </div>
                    : ""
                }

                {action === 'StopShiftLineOwner' ?
                    <React.Fragment>
                        {genDatePicker(
                            classes,
                            stopDate !== null ? moment(stopDate).format(dateFormat) : undefined,
                            { id: "stop", target: "stopDate" },
                            this.handleChange,
                            "End Date",
                            false,
                            this.getMinDatePause({ id: "stop", target: "stopDate" }),
                            this.getMaxDatePause({ id: "stop", target: "stopDate" }),
                            this.disabledDayPause,
                            this.isStopDisabled(),
                        )}
                    </React.Fragment>
                    : ""
                }
                {(action === 'ManageOwners' || action === 'ManageAssignment' || action === 'PauseShiftLineOwner' || action === 'StopShiftLineOwner')
                    ? <Button
                        disabled={showNewEntryForm
                            || (action === 'PauseShiftLineOwner' && this.noPauseSelected())
                            || this.freeSlot()
                            || (action === 'ManageOwners' && fullOwner)}
                        className={classes.addButton}
                        onClick={_ => { this.setState({ showNewForm: true }) }}
                        variant="outlined"
                        color="primary">
                        {action === 'ManageOwners' ? "Assign Owner" : "Add Relief"}
                    </Button> : ''}
                {this.newEntryForm(showNewEntryForm)}
                {renderSegments()}
                <ModalV2
                    style={{ maxWidth: 500 }}
                    open={showPopopOverlap}
                    closeModal={() => this.setState({ showPopopOverlap: false })}
                >
                    <div style={{ padding: 16 }}>
                        <div style={{ marginBottom: 16 }}> The date selection might overlap some reliefs.</div>
                        <table style={{ marginLeft: 16 }}>{reliefOverlapped.map(relief => {
                            return <tr>
                                <td>{relief.employeeName + ' : '}</td>
                                <td>{relief.startDate}<FontAwesomeIcon className={classes.arrowIcon} icon={faLongArrowRight} />{relief.endDate}</td>
                            </tr>
                        })}
                        </table>
                        <div style={{ marginTop: 16, display: 'flex' }}>
                            <div style={{ marginRight: 16, marginTop: 15 }}>Would you like to override the relief(s)?</div>
                            <RadioButtons
                                color="primary"
                                name="radiosOverlap"
                                value={radioOverlapSelected}
                                onChange={(e) => this.setState({ radioOverlapSelected: e.target.value })}
                                radios={radiosOverlap}
                                formControlClass={classes.divRadio}
                            />
                        </div>
                    </div>
                    <ActionButtons
                        cancel={() => this.setState({ showPopopOverlap: false, radioOverlapSelected: 'no' })}
                        submit={() => this.handleSubmitPopopOverlap()}
                    // disabledSubmit={disabledSubmit}
                    />
                </ModalV2>

            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedWorkPlan: state.selectedWorkPlan,
        schedulePatternsTemplates: state.schedulePatternsTemplates,
        showSidePanel: state.showSidePanel,
        snackbar: state.snackbar,
        httpOptions: state.httpOptions,
        paycodeList: state.paycodeList
    }
}

const mapDispatchToProps = {
    updateShowSidePanel,
    updateSnackbar,
    updateSelectedPaycode
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(actionFormAssignEmployee)));